"use client";

import { FOOTER_DOG_PEEK as PEEK } from "@/app/(public)/shared/_logic/constants";
import { LookingDog } from "@/app/(public)/shared/components/LookingDog";
import { motion, useInView, useReducedMotion } from "motion/react";
import { useRef } from "react";

/**
 * The party-hat dog peeking up from the bottom edge of the public footer. It
 * rises once the bottom of the page is in view and its eyes follow the cursor.
 *
 * @returns The strip with the dog.
 */
export const FooterDog = () => {
  // Hooks
  const stripRef = useRef<HTMLDivElement>(null);
  const inView = useInView(stripRef, { amount: PEEK.inViewAmount });
  const reduceMotion = useReducedMotion();

  // Derived values
  const y = inView ? PEEK.shown : PEEK.hidden;

  // Render
  return (
    <div ref={stripRef} className="w-full h-[clamp(64px,8vw,104px)] overflow-hidden flex items-end justify-center">
      <motion.div
        className="w-[clamp(84px,10vw,132px)]"
        initial={false}
        animate={{ y }}
        transition={reduceMotion ? { duration: 0 } : PEEK.spring}
      >
        <LookingDog sizes="132px" />
      </motion.div>
    </div>
  );
};
